export const isDef = (value) => typeof value !== 'undefined';

export const isString = (value) => typeof value === 'string';